export default __webpack_public_path__ + "static/media/gemcity.1577ccbb.png";